import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

const NAV_LINKS = [
  { to: '/',             label: 'Home' },
  { to: '/evaluation',   label: 'Evaluation' },
  { to: '/capabilities', label: 'Capabilities' },
  { to: '/workflow',     label: 'Workflow' },
  { to: '/analytics',    label: 'Analytics' },
  { to: '/request-demo', label: 'Request Demo' },
];

const FEATURES = [
  'AI Evaluation Engine',
  'III Score — Q&A Intelligence',
  'AI Draft Generator',
  'Org Rules Compliance',
  'Workflow & RBAC',
  'Analytics Dashboard',
];

export default function Footer() {
  return (
    <footer className={styles.footer} role="contentinfo">

      {/* ── CTA STRIP ───────────────────────────────────────────── */}
      <div className={styles.ctaStrip}>
        <div className={`wrap ${styles.ctaInner}`}>
          <div className={styles.ctaLeft}>
            <span className={styles.ctaPill}>Smarter documents. Sharper AI.</span>
            <span className={styles.ctaText}>
              Enterprise Document Intelligence for GenAI Readiness
            </span>
          </div>
          <Link to="/request-demo" className={styles.ctaBtn}>Request a Demo →</Link>
        </div>
      </div>

      {/* ── MAIN BODY ───────────────────────────────────────────── */}
      <div className={`wrap ${styles.body}`}>

        {/* Brand col */}
        <div className={styles.brand}>
          <div className={styles.logoRow}>
            {/* <div className={styles.badge}>RIQ</div> */}
             <img src='/images/logo.png' alt='ReadIQ'></img>
            <div>
              <div className={styles.logoName}>ReadIQ.ai</div>
              <div className={styles.logoSub}>Content Intelligence-Built for humans, Ready for AI</div>
            </div>
          </div>
          <p className={styles.brandDesc}>
            Built for humans, Ready for AI. ReadIQ evaluates, scores and
            auto-improves enterprise documents for GenAI readiness — at scale.
          </p>
          <div className={styles.powered}>
            <span>Powered by </span>
            <strong>ProAutomate.ai</strong>
          </div>
        </div>

        {/* Platform nav col */}
        <div className={styles.col}>
          <h3 className={styles.colHead}>Platform</h3>
          <ul className={styles.colList} role="list">
            {NAV_LINKS.map(l => (
              <li key={l.to}>
                <Link to={l.to} className={styles.colLink}>{l.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Features col */}
        <div className={styles.col}>
          <h3 className={styles.colHead}>Features</h3>
          <ul className={styles.colList} role="list">
            {FEATURES.map(f => (
              <li key={f} className={styles.featureItem}>
                <span className={styles.featureDot} />
                {f}
              </li>
            ))}
          </ul>
        </div>

        {/* Contact col */}
        <div className={styles.col}>
          <h3 className={styles.colHead}>Get In Touch</h3>
          <ul className={styles.colList} role="list">
            <li className={styles.contactItem}>
              <span className={styles.contactLabel}>Email</span>
              <a href="mailto:sam@proautomate.ai" className={styles.contactEmail}>
                sam@proautomate.ai
              </a>
            </li>
            <li className={styles.contactItem}>
              <span className={styles.contactLabel}>Location</span>
              <span className={styles.contactVal}>New Jersey, USA</span>
            </li>
            <li className={styles.contactItem}>
              <span className={styles.contactLabel}>Hours</span>
              <span className={styles.contactVal}>Mon–Fri, 9 AM–6 PM EST</span>
            </li>
            {/*<li className={styles.contactItem}>
              <span className={styles.contactLabel}>Web</span>
              <a href="https://proautomate.ai" target="_blank" rel="noreferrer"
                 className={styles.contactEmail}>proautomate.ai</a>
            </li> */}
          </ul>
        </div>

      </div>

      {/* ── DIVIDER ─────────────────────────────────────────────── */}
      <div className={styles.divider} />

      {/* ── BOTTOM BAR ──────────────────────────────────────────── */}
      <div className={`wrap ${styles.bottomBar}`}>
        <p className={styles.copyright}>
          © {new Date().getFullYear()} AI Business Solutions. All rights reserved.
        </p>
         {/*<div className={styles.bottomLinks}>
          <a href="#" className={styles.bottomLink}>Privacy Policy</a>
          <span className={styles.dot}>·</span>
          <a href="#" className={styles.bottomLink}>Terms of Use</a>
          <span className={styles.dot}>·</span>
          <a href="#" className={styles.bottomLink}>Contact</a>
        </div> */}
      </div>

    </footer>
  );
}
